/**
 * A random 128-bit id as text: a UUID where the browser offers one, else 32
 * hex characters.
 *
 * `crypto.randomUUID` needs a secure context and on-prem deployments often
 * serve plain HTTP, so `getRandomValues` (available there) is the fallback.
 */
export const newRandomId = (): string => {
  if (typeof crypto !== "undefined") {
    if (crypto.randomUUID) return crypto.randomUUID();
    if (crypto.getRandomValues) {
      const bytes = crypto.getRandomValues(new Uint8Array(16));
      return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
    }
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
